
      // Import the functions you need from the SDKs you need
      import { initializeApp } from "https://www.gstatic.com/firebasejs/10.12.4/firebase-app.js";
      import { getAnalytics } from "https://www.gstatic.com/firebasejs/10.12.4/firebase-analytics.js";
      // TODO: Add SDKs for Firebase products that you want to use
      // https://firebase.google.com/docs/web/setup#available-libraries

      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      const firebaseConfig = {
        apiKey: "AIzaSyBMeEYzrnMCi66V1iR8UAcMLiLtj2UI45M",
        authDomain: "cellula-website.firebaseapp.com",
        projectId: "cellula-website",
        storageBucket: "cellula-website.appspot.com",
        messagingSenderId: "472503408586",
        appId: "1:472503408586:web:c8ca7fb64012974abde133",
        measurementId: "G-L0SLW2E53D"
      };

      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      const analytics = getAnalytics(app);
    